module.exports = __webpack_public_path__ + "static/media/tds.e7d0fa8d.png";